import React, { Component } from 'react';
import { Menu, Dropdown, Icon, Button } from 'antd';
import { connect } from 'react-redux';


const CreatePermissionHoc = (required_permission = {}, options = {}) => {
  class HOC extends Component {
    create_component() {
      const user_permissions = this.props.current_user.user ? this.props.current_user.user.permissions : [] || [];
      const menu = (
        <Menu>
          <Menu.Item key="1" onClick={options.onBulkClick}>
            <Icon type="upload" />{options.bulkText}
          </Menu.Item>
        </Menu>
      );
      if (user_permissions.includes(required_permission["bulk_permission"]) && user_permissions.includes(required_permission["create_permission"])) {
        return (<Dropdown.Button type="primary" onClick={options.onCreateClick} overlay={menu}>
          {options.createText}
        </Dropdown.Button>);
      }
      else if (user_permissions.includes(required_permission["create_permission"])) {
        return (<Button type="primary" onClick={options.onCreateClick}>
          {options.createText}
        </Button>);
      }
      else if (user_permissions.includes(required_permission["bulk_permission"])) {
        return (<Button type="primary" onClick={options.onBulkClick}>
          <Icon type="upload" />{options.bulkText}
        </Button>);
      }
      else {
        return null
      }
    }

    renderFallback() {
      return (options.hasOwnProperty('fallbackComponent')) ? options.fallbackComponent : (<h3 className="mt-5 text-center">You're Not Authorized......</h3>)
    }

    render() {
      return this.create_component();
    }
  }
  const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
  });
  return connect(mapStateToProps)(HOC);
};
export { CreatePermissionHoc };
